/**
 * Textarea — §7.2 (mission 6 WP03 T020; FR-005). The `Input` recipe with a 96px
 * minimum height and vertical padding in place of the fixed 36px height.
 */
import * as React from 'react'

import { cn } from './cn'

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-24 w-full rounded-md border border-navy-500 bg-white px-3 py-2 text-body text-navy-950 transition-colors duration-[var(--duration-fast)]',
        'placeholder:text-navy-600 hover:border-navy-600',
        'focus-visible:border-brand-sky focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]',
        'aria-invalid:border-[var(--color-error-600)]',
        'read-only:bg-navy-50 read-only:hover:border-navy-500',
        'disabled:cursor-not-allowed disabled:border-navy-400 disabled:bg-navy-100 disabled:text-navy-600',
        className,
      )}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'
